export enum PartnerType {
  JOINT_STOCK = 'JOINT_STOCK', // d.d
  LLC = 'LLC', // d.o.o.
  SIMPLE_LLC = 'SIMPLE_LLC', // j.d.o.o.
  CRAFT = 'CRAFT', // obrt
  PERSON = 'PERSON',
}
